var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.action_SelectStatus}},[_c('span',{staticClass:"color_square",style:(_vm.styleString)}),_c('span',{staticClass:"txt ellipsis"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }